import { render, staticRenderFns } from "./electricityBill.vue?vue&type=template&id=d122b4b8&scoped=true&"
import script from "./electricityBill.vue?vue&type=script&lang=js&"
export * from "./electricityBill.vue?vue&type=script&lang=js&"
import style0 from "./electricityBill.vue?vue&type=style&index=0&id=d122b4b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d122b4b8",
  null
  
)

export default component.exports